import React from "react";
import { Link } from "react-router-dom";

// Audiobook page: embed a OneDrive-hosted video responsively.
const Presentation = () => {
  // Updated OneDrive embed URL (user-provided)
  const iframeSrc =
    "https://monashuni-my.sharepoint.com/personal/rkot0010_student_monash_edu/_layouts/15/embed.aspx?UniqueId=7fdea5b4-4074-4412-a417-04217b150503&embed=%7B%22hvm%22%3Atrue%2C%22ust%22%3Atrue%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create";

  return (
    <div style={{ padding: 20 }}>
      <div style={{ marginBottom: 12 }}>
        <Link to="/book-details" className="btn btn-outline btn-back-home">
          Back to Details
        </Link>
      </div>

      <h2 style={{ marginBottom: 12 }}>Audiobook</h2>

      {/* Embed OneDrive video responsively (16:9) - larger max width */}
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div
          style={{
            position: "relative",
            paddingBottom: "56.25%",
            height: 0,
            overflow: "hidden",
          }}
        >
          <iframe
            title="Ali Learns to Breathe.mp4"
            src={iframeSrc}
            width="1280"
            height="720"
            frameBorder="0"
            scrolling="no"
            allowFullScreen
            style={{
              border: "none",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              height: "100%",
              maxWidth: "100%",
            }}
          />
        </div>
      </div>

      <p style={{ textAlign: "center", color: "#666", marginTop: 12 }}>
        If you prefer, open the video in a new tab from the button inside this
        video.
      </p>
    </div>
  );
};

export default Presentation;
